export function buildUrl(path, query) {
  const params = new URLSearchParams();

  if (query && typeof query === 'object') {
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });
  }

  return params.toString() ? `${path}?${params.toString()}` : path;
}
